import type { DrawerSize } from 'types';

// The Figma "Web_Side panel" sizes (Size=Small, Size=Medium).
export const DRAWER_WIDTHS: Record<DrawerSize, number> = {
  small: 512,
  medium: 640,
};
